module.exports = __webpack_public_path__ + "static/media/activeProfile.a7e29da3.svg";